var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","cursor":"default","user-select":"none"}},[_vm._v("SRD © 2021 立维研发组")])}
var staticRenderFns = []

export { render, staticRenderFns }